import { memo, useCallback, useContext, useRef } from "react";
import { when } from "util/support";
import type { IbanXsBank } from "features/openBanking/types";
import { useIbanXSBanksCountriesPivotActions } from "features/openBanking/actions";
import When from "ui/support/When";
import { TabLayout } from "ui/widgets/StatefulTabs";
import { useResourceContext } from "ui/widgets/Resource";
import { IbanXSBanksCountriesPivotForm } from "ui/organizms/OpenBanking/IbanXSBanksCountriesPivot";
import { IbanXSBanksCountriesPivotContext } from "./IbanXSBanksCountriesPivotContext";

const ManageIbanXSBanksCountriesPivot = () => {
    const { resource, onClose } = useResourceContext<IbanXsBank>();

    const { isLoading, pivot } = useContext(IbanXSBanksCountriesPivotContext);

    const {
        createIbanXSBanksCountriesPivot,
        updateIbanXSBanksCountriesPivot
    } = useIbanXSBanksCountriesPivotActions();

    const helpers = {
        resource,
        pivot,
        onClose,
        requestHandler: (
            pivot
                ? updateIbanXSBanksCountriesPivot
                : createIbanXSBanksCountriesPivot
        )
    };

    const helpersRef = useRef(helpers);
    helpersRef.current = helpers;

    return (
        <TabLayout
            isLoading={isLoading}
        >
            <When
                if={Boolean(resource)}
                then={useCallback(() => {
                    const {
                        onClose,
                        requestHandler,
                        pivot,
                        resource: {
                            bankId,
                            logoUrl,
                            bankGroup,
                            fullName
                        }
                    } = helpersRef.current;

                    return (
                        <IbanXSBanksCountriesPivotForm
                            resource={pivot ?? {
                                bankId,
                                logoUrl,
                                bankGroup,
                                fullName
                            }}
                            requestHandler={requestHandler}
                            onSuccess={onClose}
                            SaveActionProps={{
                                children: when(
                                    pivot,
                                    'Update',
                                    'Create'
                                )
                            }}
                        />
                    );
                }, [])}
            />
        </TabLayout>
    );
};

export default memo(ManageIbanXSBanksCountriesPivot);
